import React, { JSX, useEffect, useState } from 'react';
// import Header from '../Header/TopHeader';
// import './ResetPassword.scss';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import axios from 'axios';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate } from 'react-router-dom';
import { BackendAPI } from '../../axios';
import { useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import { EyeInvisibleOutlined, EyeOutlined, LockOutlined, ReloadOutlined, UserOutlined } from '@ant-design/icons';
import Header from '../common/header';
import Footer from '../common/footer';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Section } from '../../views/home';

const MySwal = withReactContent(Swal);

function RegistrationConfirm(): JSX.Element {
    const [active, setActive] = useState<Section>("home");
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const est = searchParams.get("est");

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const verifyUserRegistration = async () => {
            const url = `/user/registrationConfirm?est=${est}`;
            console.log("est is => :", est);
            try {
                const response = await BackendAPI.get(url);
                console.log("Registration confirm response:", response.data);
                if (response.data === 'Registration confirmed successfully, emails sent.') {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Registration confirmed successfully!',
                    }).then(() => {
                        navigate('/'); // Redirect on OK
                    });
                } else {
                    MySwal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.data || 'Failed to confirm registration.',
                    }).then(() => {
                        navigate('/'); // Redirect on OK
                    });
                }
            } catch (error) {
                console.error('Registration confirmation failed', error);
                MySwal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to confirm registration.',
                });
            } finally {
                setLoading(false);
            }
        };
        verifyUserRegistration();
    }, [est, navigate]);

        useEffect(() => {
        const sections = document.querySelectorAll("section");
    
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setActive(entry.target.id as Section);
              }
            });
          },
          { threshold: 0.5 }
        );
    
        sections.forEach((section) => observer.observe(section));
    
        return () => observer.disconnect();
      }, []);

    return (
        <>
            <Header active={active}/>
            <div className="registration-confirm-container" style={{ minHeight: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', textAlign: 'center', padding: '20px' }}>
                {/* <Card style={{ maxWidth: 600, width: '100%', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
        <h2>Registration Successful!</h2>
        <p>Your registration has been successfully completed.</p>
        {est && (<>
            <p>Your estimated time for approval is:</p>
            <h3>{est}</h3>  
        </>)}
      </Card> */}
            </div>
            <Footer />
        </>
    );
}

export default RegistrationConfirm;
